module.exports = __webpack_public_path__ + "media/images/empty-gift-74f598def45395059163b96b258100b9.png";